// WHICH SHOP'S PAGE IS THIS? (extracted from App.tsx, TW-0135.)
//
// The single most load-bearing decision this bundle makes: it picks whose consent form a client is
// about to sign, and whose records the signature lands in. Thousands of printed QR codes point at
// `<shop>.waivers.tattoo`, so deployed, the answer is the HOSTNAME and nothing else — no query
// string, no storage, nothing a link can carry.
//
// It lived inside App.tsx as a private function and so had no test of its own. It has one now, and
// pulling it out is also what lets the demo chrome be tested at all: a test can mock this module,
// where it could not move jsdom's hostname (CRA's jest ignores the @jest-environment-options
// docblock — measured 2026-09-08, jest 27.5.1).

/** Deployed, the shop IS the subdomain. On a dev server there is no subdomain, so pick one:
 *  `?shop=<sub>` on the URL, else REACT_APP_SHOP, else the demo shop, which is the only one that
 *  notifies nobody real. `./run.sh shops` lists them.
 *
 *  ⚠ THE QUERY STRING IS READ ON A DEV SERVER AND NOWHERE ELSE, and the branch above is the whole
 *  guard — the test below proves a deployed bundle ignores it, which is the property thousands of
 *  printed QR codes rest on. It is here because REACT_APP_SHOP is read once at server START, so
 *  seeing a shop you just minted at /start meant restarting the whole `./run.sh dev` stack; the
 *  cold walk (mint → QR → a client signs) could not be done locally in one sitting (2026-09-19). */
export function currentSubdomain(): string {
  if (process.env.NODE_ENV === "development") {
    const asked = new URLSearchParams(window.location.search).get("shop") || "";
    if (/^[a-z0-9-]{1,63}$/.test(asked)) return asked;
    return process.env.REACT_APP_SHOP || "demo";
  }
  return window.location.hostname.split(".")[0];
}

/** The demo shop is the only page with dials, a state picker or a QR code on it. A printed code on
 *  a counter must never open a page a client can reconfigure. */
export const isDemoShop = (subdomain: string): boolean => subdomain === "demo";
